import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BillingUsageService } from 'src/app/views/my-space/billing-usage/billing-usage.service';
import { ToastService } from './toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private dialog = inject(MatDialog);
  private billingService = inject(BillingUsageService);

  constructor(
    private toast: ToastService,
    private translate: TranslateService,
    private router: Router
  ) {}
  handle401Error(err) {
    if (err.error?.err == 'not-allowed-to-create-content') {
      const snackBarRef = this.toast.snackbar.open(this.translate.instant('Snackbar.NotAllowedToCreateContent'), this.translate.instant('MySpace.Upgrade') || 'Upgrade', {
        duration: 8000,
      });
      snackBarRef.onAction().subscribe(() => {
        this.router.navigate(['/myspace/billing-usage']);
      });
      return true;
    }
    if (err.status == 401) {
      this.toast.snackbar.open(this.translate.instant('Snackbar.SessionExpired'), this.translate.instant('Ok') || 'OK', {
        duration: 4000,
      });
      return true;
    } else return false;
  }

  handleAiRestrictedError(err: any): boolean {
    if (err.status === 403 && err.error?.error === 'ai-restricted') {
      this.toast.snackbar.open(this.translate.instant('AiRestrictedAlert.Title'), this.translate.instant('Ok') || 'Ok', { duration: 2000 });
      this.billingService.aiRestrictedAlertTriggered.set(true);
      return true;
    }
    this.toast.snackbar.open(this.translate.instant('Snackbar.ErrorOccured'), this.translate.instant('Ok') || 'Ok', { duration: 2000 });
    return false;
  }
}
